import React from 'react';
import { Image } from '@weareconceptstudio/core';
const ListItem = ({ item }) => {
    let element;
    const isImageFileType = (type) => type.indexOf('image/') === 0;
    if (isImageFileType(item.mime_type)) {
        element = React.createElement(Image, { src: item.url });
    }
    return React.createElement("span", { className: 'list-item-container' }, element);
};
export default ListItem;
//# sourceMappingURL=index.js.map